<script lang="ts">
import { token } from './store.js';
import * as config from "./config.json";

async function apiGetRequest(endpoint) {
  const response = await fetch( config.api_url.concat(endpoint), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + $token
      }
  });
  const text = await response.json();

  if (response.ok) {
    return text;
  } else {
    throw new Error(text);
  }
}

async function controlServer(endpoint, action) {
  const response = await fetch( config.api_url.concat(endpoint), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + $token
      },
      body: JSON.stringify({action: action})
  });
  const text = await response.json();

  if (response.ok) {
    return text;
  } else {
    throw new Error(text);
  }
}

let instances = apiGetRequest('/servers');

setInterval(async function(){
  instances = await apiGetRequest('/servers');
}, 8000);

async function controlClick(id, action) {
  await controlServer("/servers/" + id, action);
  instances = await apiGetRequest('/servers');
}
</script>

{#await instances}
<p>Fetching Instances</p>
{:then instance_response}
  {#each instance_response as { id, state }, i}
    <div class="bg-gray-300">
      <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
        <h2 class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
          <span class="block">{id}</span>
          {#if state == "stopped"}
            <span class="block text-red-600">
            {state}
            </span>
          {:else}
            <span class="block text-green-600">
            {state}
            </span>
          {/if}
        </h2>
        <div class="mt-8 lex lg:mt-0 lg:flex-shrink-0">
          <div class="inline-flex rounded-md shadow">
            {#if state == "stopped"}
              <button type="submit" class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-black bg-green-300 hover:bg-green-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-100" on:click={() => controlClick(id, "start")}>
                start
              </button>
            {:else if state == "running"}
              <button type="submit" class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-black bg-red-300 hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-100" on:click={() => controlClick(id, "stop")}>
                stop
              </button>
            {:else if state == "starting" || state == "stopping"}
              <button type="submit" class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-black bg-gary-300" disabled>
                waiting
              </button>
            {/if}
          </div>
        </div>
      </div>
    </div>
  {/each}
{/await}